export default {
  addInvoice: {
    billInfo: {
      title: '发票信息',
      payableInvoiceCompanyCode: '公司代码',
      companyNoPlaceholder: '请选择公司代码',
      payableInvoiceCompanyName: '公司名称',
      documentCode: '单据编号',
      payableInvoiceCreatePerson: '制单人',
      payableInvoiceCreateDate: '制单日期',
      payableInvoiceStatus: '单据状态',
      invoiceUnitNo: '开票单位',
      issuingOfficePlaceholder: '请选择开票单位',
      invoiceUnitName: '开票单位名称',
      invoiceUnitNamePlaceholder: '请选择开票单位',
      invoiceType: '发票类型',
      invoiceTypePlaceholder: '请选择发票类型',
      invoiceCode: '发票编号',
      invoiceNoPlaceholder: '请填写发票编号',
      invoiceNumber: '发票张数',
      currencyCode: '币种',
      currencyPlaceholder: '请选择币种',
      goldenTaxTypePlaceholder: '请选择增值税发票类型',
      originalTotalAmount: '发票原币总金额',
      originalCurrencyTotalAmountPlaceholder: '请填写发票原币总金额',
      originalTotalWithoutTaxAmount: '原币不含税金额',
      originalCurrencyAmountExcludingtaxPlaceholder: '请填写原币不含税金额',
      originalTaxAmount: '原币税额',
      originalMoneyTaxPlaceholder: '请填写原币税额',
      exchangeType: '汇率类型',
      exchangeTypePlaceholder: '请选择汇率类型',
      exchangeRate: '汇率',
      exchangeRatePlaceholder: '请填写汇率',
      exchangeDate: '汇率日期',
      exchangeDatePlaceholder: '请填写汇率日期',
      domesticTotalAmount: '本币总金额',
      domesticTotalWithoutTaxAmount: '本币不含税金额',
      domesticTaxAmount: '本币税额',
      exchangeLost: '汇兑损溢',
      mark: '备注',
      remarksPlaceholder: '请填写备注',
      belongPeriod: '归属日期',
    },
    accountingInfo: {
      title: '会计信息',
      postStatus: '入账状态',
      postDate: '入账日期',
      voucherCode: '凭证编号',
      reversePostDate: '冲销入账日期',
      reverseVoucherCode: '冲销凭证编号',
      payableAccount: '应付科目',
    },
    payInfo: {
      lineNum: '行号',
      paymentApplyNumber: '付款申请单号',
      paymentNum: '付款单号',
      lineNumber: '付款单行号',
      appliedAmount: '付款金额',
      paymentDate: '付款日期',
      total: '合计',
    },
    invoiceLine: {
      title1: '发票行',
      title2: '会计凭证',
      title3: '付款信息',
      btns: {
        matching: '匹配采购合同',
        delete: '删除行',
        add: '新增行',
        save: '保存',
      },
      table: {
        payableInvoiceDepartmentCode: '部门编码',
        // payableInvoiceDepartmentCode:"部门名称",
        amountExcludingTax: '',
        payableInvoiceDetailNo: '行号',
        expenseGroup: '费用大类',
        expenseType: '费用类型',
        departmentCode: '部门代码',
        departmentName: '部门名称',
        purchaseContractNo: '采购合同号',
        purchaseContractDetailNo: '采购合同行项目号',
        inboundCode: '业务入库单号',
        returnNo: '退货单号',
        inboundBatchNo: '入库批次号',
        productDesc: '商品描述',
        invoiceUnit: '单位',
        matchInboundQuantity: '本次匹配入库数量',
        inboundUnitPrice: '入库单价',
        inboundExchangeRate: '入库汇率',
        originProvisionalAmount: '应付暂估原币金额',
        localProvisionalAmount: '应付暂估本币金额',
        originInvoiceDifferPrice: '原币发票价差',
        localInvoiceDifferPrice: '本币发票价差',
        exchangeLost: '汇兑损溢',
        exchangeRate: '汇率',
        overShippedQuantity: '溢短装数量',
        invoiceQuantity: '本次收票数量',
        invoiceUnitPrice: '发票单价',
        invoiceUnitPriceWithTax: '发票含税单价',
        amountWithoutTax: '不含税金额',
        taxRate: '税率',
        taxCode: '税码',
        taxAmount: '税额',
        totalAmount: '总额',
        domesticTotalWithoutTaxAmount: '本币不含税金额',
        domesticTaxAmount: '本币税额',
        domesticTotalAmount: '本币总额',
        salesContractNo: '销售合同号',
        salesLadingNo: '销售提单号',
        batchSettleNo: '结算批次',
        mark: '备注',
        isReverseAlias: '冲销标识',
      },
      rules: {
        input: '请填写',
        select: '请选择',
      },
    },
    btns: {
      generatePaymentDocument: '生成付款申请单',
      save: '保存',
      edit: '编辑',
      submission: '提交',
      withdraw: '撤回',
      delete: '删除',
      printing: '打印',
      return: '退回',
      accountEntry: '生成凭证',
      writeOff: '冲销',
    },
    prompt: {
      writeOffEntryDate: '请选择冲销日期',
      accountEntryDate: '请选择入账日期',
    },
    warnInfo: {
      infoInfo: '请填写发票信息',
      ledgerInfo: '请先配置公司账套',
      needLowZero: '当选择红票时，发票原币金额需小于0！',
      needOverZero: '当选择蓝票时，发票原币金额需大于0！',
    },
    confirm: {
      withdraw: {
        title: '撤回单据？',
        content: '是否撤回单据？',
      },
      returned: {
        title: '退回单据？',
        content: '是否退回单据？',
      },
      toleranceCheck: {
        title: '允差校验',
        content: '发票超过允差范围，请确认发票填写是否无误？',
      },
    },
  },
};
